{
  "Earlier": "EARLIER",
  "newNotification": "{newCount} new notification",
  "newNotifications": "{newCount} new notifications",
  "noNotifications": "You will receive important information about our products, your collaboration with fellow users, and other relevant updates",
  "noNotificationsTitle": "Your Notifications will appear here"
} 
